import { render } from "./messageLogs.vue?vue&type=template&id=b5521798"
import script from "./messageLogs.vue?vue&type=script&lang=js"
export * from "./messageLogs.vue?vue&type=script&lang=js"

import "./messageLogs.vue?vue&type=style&index=0&id=b5521798&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__